// Route names must be unique and start with /
const routes = {
  main: "/:code",
  shorten: "/shorten",
  login: "/login",
  signup: "/signup",
  dashboard: "/dashboard",
  view: "/view/:code",
  settings: "/settings/:slug",
  confirmAccount: "/confirm/:uut",
  resetPassword: "/reset-password",
  reset: "/reset/:token",
  privacy: "/privacy",
  termsConditions: "/terms-conditions",
  redirects: "/redirects",
  checkSubmit: "/check",
  check: "/:code/check",
  tags: "/tags",
};

export default routes;
